<mat-toolbar
    class="filter-toolbar"
    [ngClass]="{
        'single-sort-row': isSingleSort,
        'dialog-option': dialogOption,
        'single-row': isCaseHistoryAdvanced
    }"
    *ngIf="!loadingConfig; else loading">
    <mat-toolbar-row class="action-row" *ngIf="!isSingleSort">
        <button
            (click)="reset()"
            mat-icon-button
            matTooltip="{{ isSimpleSearch ? 'Clear search' : 'Reset filters' }}"
            matTooltipClass="redClass"
            matTooltipPosition="above">
            <span class="material-icons-outlined">
                settings_backup_restore
            </span>
        </button>
        <filter-sorting
            *ngIf="!isSimpleSearch"
            [hideIfEmpty]="isCaseHistoryAdvanced"></filter-sorting>
        <filter-search></filter-search>
        <filter-filtering *ngIf="!isSimpleSearch"></filter-filtering>
    </mat-toolbar-row>

    <ng-container *ngIf="selectedSorts$ | async as selectedSorts">
        <mat-toolbar-row
            [ngClass]="isSingleSort ? 'single-sort' : null"
            class="sort-row"
            *ngIf="selectedSorts.length > 0 && !isSimpleSearch">
            <filter-selected-sorts
                [allowDisableRemove]="isCaseHistoryAdvanced"
                [selectedSorts]="selectedSorts"></filter-selected-sorts>
        </mat-toolbar-row>
    </ng-container>

    <ng-container *ngIf="selectedFilters$ | async as selectedFilters">
        <mat-toolbar-row class="filters-row" *ngIf="selectedFilters.length > 0">
            <filter-selected-filters
                [selectedFilters]="selectedFilters"></filter-selected-filters>
        </mat-toolbar-row>
    </ng-container>
</mat-toolbar>

<ng-template #loading>
    <mat-toolbar
        class="filter-toolbar loader"
        [ngClass]="{
            'dialog-option': dialogOption,
            'single-sort-loader': isSingleSort
        }">
        <mat-toolbar-row class="action-row">
            <mat-spinner [diameter]="20"></mat-spinner>
        </mat-toolbar-row>
    </mat-toolbar>
</ng-template>
